<template>
  <div class="organizer-container">
    <text-field
      :admin-context="isAdminLocalization"
      v-model.trim="form.publicName"
      :label="adminText('adminAll.organization_public_name_e8c828', 'Organization public name')"
      :validator="vs.form.publicName"
      :disabled="!enableEditing"
    />
    <text-field
      :admin-context="isAdminLocalization"
      v-model.trim="form.email"
      :validator="vs.form.email"
      :label="adminText('adminAll.email_84add5', 'Email')"
      :disabled="!enableEditing"
    />
    <div class="organizer-info">
      <logo-field v-model="form.logo" class="logo" :disabled="!enableEditing" />
      <textarea-field
        v-model="form.description"
        :validator="vs.form.description"
        :label="adminText('adminAll.organizer_description_6d58cb', 'Organizer description')"
        :disabled="!enableEditing"
      />
    </div>
    <section class="online-presence">
      <div class="online-presence__header">
        <h2 class="online-presence__title">{{ adminText('adminAll.online_presence_88dcca', 'Online presence') }}</h2>
        <p class="online-presence__description">
          {{ adminText('adminAll.help_visitors_find_your_organization_all_links_are_optiona_e93af2', 'Help visitors find your organization. All links are optional and should start with https://.') }}
        </p>
      </div>
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.webLink"
        :validator="vs.form.webLink"
        :error-messages="linkErrorMessages"
        :label="adminText('adminAll.website_2e8a57', 'Website')"
        :placeholder="adminText('adminAll.https_your_organization_com_e3d79a', 'https://your-organization.com')"
        :disabled="!enableEditing"
      />
      <div class="online-presence__social-links">
        <text-field
          :admin-context="isAdminLocalization"
          v-model.trim="form.facebookLink"
          :validator="vs.form.facebookLink"
          :error-messages="linkErrorMessages"
          :label="adminText('adminAll.facebook_82da67', 'Facebook')"
          :placeholder="adminText('adminAll.https_facebook_com_2f1bc2', 'https://facebook.com/...')"
          :disabled="!enableEditing"
        />
        <text-field
          :admin-context="isAdminLocalization"
          v-model.trim="form.instagramLink"
          :validator="vs.form.instagramLink"
          :error-messages="linkErrorMessages"
          :label="adminText('adminAll.instagram_5721bb', 'Instagram')"
          :placeholder="adminText('adminAll.https_instagram_com_6cbd55', 'https://instagram.com/...')"
          :disabled="!enableEditing"
        />
        <text-field
          :admin-context="isAdminLocalization"
          v-model.trim="form.linkedinLink"
          :validator="vs.form.linkedinLink"
          :error-messages="linkErrorMessages"
          :label="adminText('adminAll.linkedin_6b6390', 'LinkedIn')"
          :placeholder="adminText('adminAll.https_linkedin_com_6cfa87', 'https://linkedin.com/...')"
          :disabled="!enableEditing"
        />
        <text-field
          :admin-context="isAdminLocalization"
          v-model.trim="form.youtubeLink"
          :validator="vs.form.youtubeLink"
          :error-messages="linkErrorMessages"
          :label="adminText('adminAll.youtube_558865', 'YouTube')"
          :placeholder="adminText('adminAll.https_youtube_com_4e3931', 'https://youtube.com/...')"
          :disabled="!enableEditing"
        />
      </div>
    </section>
    <main-button
      :text="adminText('adminAll.save_efc007', 'Save')"
      depressed
      class="button"
      :disabled="!enableEditing || !isFormValid"
      @click="$emit('submit')"
    />
  </div>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'organizer-profile',
  props: {
    enableEditing: {
      type: Boolean,
      default: () => false,
    },
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedLanguage: '',
      allLanguages: require('../../assets/languages.json'),
      form: this.initialValues,

    }
  },
  computed: {
    linkErrorMessages() { return {
      httpUrl: this.adminText('adminAll.enter_a_full_url_for_example_https_example_com_bb3f72', 'Enter a full URL, for example https://example.com.'),
    } },
    isFormValid(){
      return !this.vs.form.$invalid && !this.vs.form.$error
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted() {
    Object.entries(this.allLanguages).find(([key, value]) => {
      if (key === this.initialValues.preferredLanguage) {
        this.selectedLanguage = value.name
      }
    })
  },
  methods: {
    selectLan(language) {
      let selectedLanguage
      Object.entries(this.allLanguages).find(([key, value]) => {
        if (value.name === language) {
          return (selectedLanguage = key)
        }
      })
      this.form.preferredLanguage = selectedLanguage
    },
    getLanguagesList() {
      const list = []
      Object.entries(this.allLanguages).forEach(([key, value]) => {
        list.push(value.name)
      })

      return list
    },
  },
}
</script>

<style scoped>
.organizer-container {
  display: flex;
  row-gap: 2rem;
  flex-direction: column;
}
.organizer-name {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
}
.organizer-info {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
}
.button {
  width: 6.25rem;
  align-self: flex-end;
}
.online-presence {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 0.5rem;
  border-top: 1px solid #e6e6e6;
}
.online-presence__header {
  margin-bottom: 0;
}
.online-presence__title {
  margin: 0 0 0.375rem;
  color: #ff4c00;
  font-family: 'Raleway';
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.03em;
}
.online-presence__description {
  margin: 0;
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  line-height: 1.5;
}
.online-presence__social-links {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 1.5rem;
  row-gap: 1.25rem;
}
.title {
  font-family: 'Raleway';
  font-style: normal;
  margin-bottom: 0.75rem !important;
  font-weight: 600;
  font-size: 20px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
}
.title-descriptions {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #979797;
}
@media screen and (max-width: 600px) {
  .online-presence__social-links {
    grid-template-columns: 1fr;
  }
}
@media screen and (max-width: 413px) {
  .logo {
    margin: 0 auto;
  }
}
</style>
